/* src/app/shared/modal-dialog/filter-help/filter-help-dialog.component.scss */
.filter-help-content {
  padding: 1rem;
}
.filter-help-content h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.5rem;
}
.filter-help-content .help-section {
  margin-bottom: 1.5rem;
}
.filter-help-content .help-section h4 {
  color: #495057;
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.filter-help-content .help-section h4 i {
  color: #007bff;
}
.filter-help-content .help-section p {
  margin: 0 0 0.5rem 0;
  color: #666;
  line-height: 1.6;
}
.filter-help-content .help-section ul {
  margin: 0;
  padding-left: 1.5rem;
  color: #666;
}
.filter-help-content .help-section ul li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}
.filter-help-content .help-section:last-child {
  margin-bottom: 0;
}
.filter-help-content .dialog-footer {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=filter-help-dialog.component.css.map */
